import { render, staticRenderFns } from "./ksExpireRemind.vue?vue&type=template&id=7cded8ea&scoped=true&"
import script from "./ksExpireRemind.vue?vue&type=script&lang=js&"
export * from "./ksExpireRemind.vue?vue&type=script&lang=js&"
import style0 from "./ksExpireRemind.vue?vue&type=style&index=0&id=7cded8ea&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cded8ea",
  null
  
)

export default component.exports